import { Tr, Td } from '@patternfly/react-table'
import * as React from 'react'
import { useCallback } from 'react'

import type { IDomainEvent } from '@app/domain/domain-events/domain-events.interface'

interface Props {
  className?: string
  domainEvent: IDomainEvent
  expandedRows: { [key: string]: boolean }
  handleExpanded: (domainEventId: string) => void
  index: number
}

export const DefaultDomainEventHeader = function ({
  domainEvent,
  expandedRows,
  handleExpanded,
  index,
}: Props) {
  const handleExpansionToggle = useCallback(() => {
    handleExpanded(domainEvent.id)
  }, [domainEvent, handleExpanded])

  return (
    <Tr>
      <Td
        expand={{
          rowIndex: index,
          isExpanded: expandedRows[domainEvent.id] ?? false,
          onToggle: handleExpansionToggle,
        }}
       />
      <Td>{domainEvent.type}</Td>
      <Td>{domainEvent.source}</Td>
      <Td>{domainEvent.subject}</Td>
      <Td>{domainEvent.time}</Td>
      <Td />
    </Tr>
  )
}
